import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import Draggable from "react-draggable";
import OverlappingEventsContent from "./OverlappingEventsContent";

const OverlappingEventsModal = (props) => {
  const { visible, handleCancel, handleContinue, allowedOverlapping } = props;

  const [disabled, setDisabled] = useState(true);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!visible) {
      setCurrent(0);
    }
  }, [visible]);

  const onMouseOver = () => {
    setDisabled(false);
  };

  const onMouseOut = () => {
    setDisabled(true);
  };

  return (
    <Modal
      maskClosable={false}
      title={null}
      destroyOnClose={true}
      width={"max-content"}
      styles={{
        body: {
          padding: "2px 0 0 0",
        },
      }}
      closable={false}
      open={visible}
      onCancel={handleCancel}
      modalRender={(modal) => (
        <Draggable disabled={disabled}>{modal}</Draggable>
      )}
      footer={null}
    >
      <OverlappingEventsContent
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        current={current}
        hide={handleCancel}
        handleContinue={handleContinue}
        allowedOverlapping={allowedOverlapping}
      />
    </Modal>
  );
};

export default OverlappingEventsModal;
